import React from 'react'
import './RoomsSec1.css';

const RoomsSec1 = () => {
  return (
    <div>
        <div className='image'>
            <img className='imgr1'src='./r1.png'alt='hhh'/>
            <p className='centered'>ROOMS</p>
        </div>
    </div>
  )
}

export default RoomsSec1